import React from 'react';
import { isEmpty, kebabCase } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Button from '../layouts/Button';

export default function ActivitiesCard({ data }) {
  const { title, text, links, image } = data;
  const isBrowser = typeof window !== 'undefined';

  const getLinks = () => {
    if (isEmpty(links) || !isBrowser) return [];
    if ((links.length = 2)) {
      const { userAgent } = navigator;
      if (/iPad|iPhone|iPod|Mac|Macintosh/i.test(userAgent)) return links[0];
      return links[1];
    }
    if ((links.length = 1)) return links[0];
    return [];
  };

  const link = getLinks();

  return (
    <div
      id={kebabCase(title)}
      className="relative lg:h-[401px] md:h-[350px] h-[395px] before:!inline
      before:content-[''] before:absolute before:top-0 before:w-full before:h-full
      before:bg-black before:bg-opacity-60"
    >
      {isEmpty(image) || (
        <LazyLoadImage src={image.url} alt={title} className="w-full h-full object-cover" />
      )}

      <div
        className={`absolute top-0 flex md:flex-row flex-col md:justify-between h-full
        w-full 4xl:px-[200px] 2xl:px-[100px] lg:px-[50px] md:px-[30px] px-4 ${
          links ? 'md:justify-between justify-center' : ''
        }`}
      >
        <div
          className="flex flex-col lg:gap-y-8 gap-y-3 3xl:pt-[85px] lg:pt-[75px]
        md:pt-[60px] pt-[0px] lg:pb-[129px] md:pb-[40px] pb-[30px] 3xl:w-[45.5%]
        lg:w-[59%] md:w-[65%]"
        >
          <h4
            className="text-white font-roboto-condensed-bold text-[23px]
          md:leading-[46px] leading-8 uppercase"
          >
            {title}
          </h4>
          <p
            className="text-white font-roboto-regular lg:text-base text-[15px]
          leading-6"
          >
            {text}
          </p>
        </div>
        {isEmpty(link) || (
          <div
            className="flex md:flex-col flex-row flex-wrap md:gap-y-5 gap-y-3 md:h-full
            gap-x-4 items-center md:justify-center md:w-[23%]"
          >
            <Button
              label={link.name}
              url={link.url}
              ariaLabel={link.name}
              tagName={kebabCase(link.name)}
              text="md:w-auto w-auto h-[42px] md:px-8 !px-4"
              variant="primaryRed"
            />
          </div>
        )}
      </div>
    </div>
  );
}
